import React from 'react';
import {
    Grid,
    Typography
} from '@mui/material';
import ScreenLoader from 'components/ScreenLoader';
import PositiveGraph from 'assets/png/PositiveGraph.png';
import NegativeGraph from 'assets/png/NegativeGraph.png';
import upIcon from 'assets/png/upIcon.png';
import downIcon from 'assets/png/downIcon.png';

interface CategoryStatusProps {
    title: any,
    loader: boolean,
    score: number,
    scoreVariation: number,
    boldTitle: boolean
}

const CategoryStatus = (props: CategoryStatusProps) => {
    const toPercent = (x:string) => {
        return Number.parseFloat(x).toFixed(1).toString() + '%';
      }
      
    return (
        <Grid item md={3} sm={6} xs={12}>
            <Typography component={'div'} className={ props?.scoreVariation >= 0.0 ? 'category-status-container category-status-container-normal-border' :
                'category-status-container category-status-container-highlight-border'
            }>
                {props?.loader === true ?
                    (<Typography
                        component={'div'}
                        textAlign={'center'} >
                        <ScreenLoader loading={props.loader} />
                    </Typography>
                    ) :
                    (<Typography component={'div'}>
                        <Typography component={'div'} className='d-flex'>
                            <Typography component={'div'}>
                                {props.boldTitle === true ?
                                   (<Typography component={'div'} className='c-title-bold'>{props.title}</Typography>) :
                                   (<Typography component={'div'} className='c-title'>{props.title}</Typography>)
                                }                                
                                <Typography className='total-title'>{props.score}</Typography>
                            </Typography>
                            <Typography component={'div'} className='image-container'>
                            { props?.scoreVariation >= 0.0 ?
                            (
                                <img src={PositiveGraph} className='image-graph' alt='Positive Graph' />
                            ):
                            (
                                <img src={NegativeGraph} className='image-graph' alt='Positive Graph' />
                            )}
                            </Typography>
                        </Typography>
                            <Typography component={'div'} className='footer-container d-flex'>
                                <Typography component={'span'} style={{width:'80%'}}>Compared to last month</Typography>
                                <Typography component={'div'} style={{display:'flex', justifyContent:'flex-end', width:'20%', marginRight:'15px'}}>
                                    <Typography className={props?.scoreVariation >= 0 ? 'd-flex down-box-plus' : 'd-flex down-box-minus'}>
                                        {props?.scoreVariation >= 0 ? '+' : ''}
                                        {toPercent(String(props?.scoreVariation))}&nbsp;
                                        <Typography component={'div'} className='img-icon-container'>{props?.scoreVariation > 0 ? 
                                                        (<img className='img-icon' src={upIcon} />) : 
                                                            props?.scoreVariation < 0 ? (<img className='img-icon' src={downIcon} />) 
                                                            : ('')}
                                        </Typography>
                                    </Typography>
                                </Typography>
                            </Typography>
                    </Typography>
                    )}
            </Typography>
        </Grid>)

}

export default CategoryStatus;